import { ReactElement } from 'react';
import { EmbeddedCompany } from 'types';
import { BoundState, Breadcrumb, ClientTitle } from 'components';
import { usePeriod } from 'modules/reporting/usePeriod';
import { RowType, startColumns, endColumns, boundStateOptions } from './common';
import { CompanyFilterChip } from 'modules/core/company/components';
import { UserFilterChip } from 'components/filters/UserFilterChip';
import { SelectFilterChip } from 'components/filters/SelectFilterChip';
import { MonthFilterChip } from 'components/filters/DatePartFilterChip';
import { ReportTable } from 'components/ReportTable';
import { ControlledTableColumns, flexColumn } from 'components/ControlledTable';

type IncomeRowType = RowType & {
  client: EmbeddedCompany;
  payer: EmbeddedCompany;
};

const columns: ControlledTableColumns<IncomeRowType> = [
  ...startColumns,
  flexColumn({
    key: 'client',
    content: 'Client',
    render: (row) => <ClientTitle {...row} />,
  }),
  ...endColumns,
  {
    key: 'state',
    configLabel: 'Status',
    width: 30,
    render: ({ state, is_overspent }) => <BoundState variant="income" state={state} is_overspent={is_overspent} />,
  },
];

export function IncomeLinks(): ReactElement {
  const { date_from: minDate, date_to: maxDate } = usePeriod();
  return (
    <ReportTable
      url="invoicing/links/income"
      columns={columns}
      filterFields={
        <>
          <Breadcrumb>Income</Breadcrumb>
          <UserFilterChip name="manager" filter={{ manage_campaign: true }} />
          <CompanyFilterChip name="client" />
          <SelectFilterChip name="state" options={boundStateOptions} />
          <MonthFilterChip name="month" minDate={minDate} maxDate={maxDate} />
        </>
      }
    />
  );
}
